import { render } from "./ClientsPhoneTab.vue?vue&type=template&id=ca3dccf8&scoped=true"
import script from "./ClientsPhoneTab.vue?vue&type=script&lang=js"
export * from "./ClientsPhoneTab.vue?vue&type=script&lang=js"

import "./ClientsPhoneTab.vue?vue&type=style&index=0&id=ca3dccf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca3dccf8"]])

export default __exports__